import { orchestrator } from 'satcheljs';
import {
    toggleEnable,
    clearPreviewOnComposeDismiss,
    updatePreviewColor,
} from 'owa-quick-compose-controller';
import {
    notifyOnCalendarIdChanged,
    onCloseFullCompose,
    onCloseQuickCompose,
} from 'owa-calendar-compose-form-store';
import { hideItemPeek } from 'owa-calendar-peek';
import { hideItemContextMenu } from 'owa-calendar-surface-contextmenu-actions';
import { focusNewEventButton } from 'owa-calendar-module-commanding';
import {
    QUICK_COMPOSE_ENTRY_SOURCE_SURFACE,
    QuickComposeEntrySourceType,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

// TODO: VSO #89735 Audit boundary between surface and board
// compose flow needs to be refactored to no longer rely on pseudo-stitches
export function registerQuickComposeStiches() {
    // subscribe for onCloseQuickCompose action clear preview item on quick compose dismiss
    orchestrator(onCloseQuickCompose, clearPreviewOnComposeDismiss);

    // subscribe for onCloseFullCompose action clear preview item on full compose dismiss
    orchestrator(onCloseFullCompose, clearPreviewOnComposeDismiss);

    // subscribe for hideItemPeek to disable quickAdd on item's peek dismiss
    orchestrator(hideItemPeek, toggleEnable);

    // subscribe for hideItemContextMenu to disable quickAdd on item's context menu dismiss
    orchestrator(hideItemContextMenu, toggleEnable);

    // subscribe for notifyOnCalendarIdChanged action to update the preview item color
    orchestrator(notifyOnCalendarIdChanged, actionMessage =>
        updatePreviewColor(actionMessage.calendarId)
    );

    // subscribe to form close notifications to focus the new event button if the
    // compose form was first opened from the surface as quick compose
    orchestrator(onCloseQuickCompose, actionMessage => {
        tryFocusNewEventButton(actionMessage.quickComposeEntrySource);
    });
    orchestrator(onCloseFullCompose, actionMessage => {
        tryFocusNewEventButton(actionMessage.quickComposeEntrySource);
    });
}

function tryFocusNewEventButton(quickComposeEntrySource: QuickComposeEntrySourceType | null) {
    if (quickComposeEntrySource == QUICK_COMPOSE_ENTRY_SOURCE_SURFACE) {
        focusNewEventButton();
    }
}
